import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import landscopeLogo from '../assets/landscope-banner.svg';
// Title block rendered in the print sheet's bottom band (Option B). Holds the
// non-map furniture: title, subtitle, description (left), and the projection +
// brand mark (right). The scale bar and north compass now live ON the map (see
// PrintMapOverlay), which frees this band for a roomier description.
//
// EXPORT CLIP SLACK: every text box here that sets `overflow: hidden` (needed
// for its ellipsis) MUST also carry EXPORT_CLIP_SLACK as padding-bottom. Keep
// both that and the explicit line-height when editing.
//
// html2canvas (the PDF exporter) doesn't lay text out. It takes the element's
// real line box top, then adds a baseline offset measured from a throwaway
// probe (html2canvas.js:6589, `img.offsetTop - span.offsetTop + 2`) and calls
// fillText. That hardcoded +2, plus rounding, draws every glyph a CONSTANT
// ~2-3px lower than the browser does, and `overflow: hidden` clips to the
// PADDING BOX (html2canvas.js:6149) — so the bottom of the type is sheared off
// in the PDF while the on-screen preview looks perfect.
//
// line-height alone does not fix this. A 1.5 line box adds half-leading of
// ~0.175 * fontSize below the glyphs, which is PROPORTIONAL to font size while
// the error is CONSTANT — measured against real exports it rescues 18px type
// (3.15px of slack) but not 13px (2.28px) or 12px (2.10px). Hence the constant
// padding below, which is what actually guarantees the clip can't reach the
// glyphs at any size.
const INK = '#2f3027';
const MUTED = '#8a8b7e';
// Bottom padding that keeps the exporter's constant baseline error clear of the
// overflow:hidden clip (see the note above). Comfortably over the measured
// ~2-3px, and small enough not to disturb the band's vertical rhythm.
const EXPORT_CLIP_SLACK = 4;
const PrintTitleBlock = ({ title, subtitle, description }) => {
    const titleText = title || 'Untitled map';
    const titleFontSize = titleText.length <= 18 ? 18 : titleText.length <= 28 ? 16 : titleText.length <= 40 ? 14 : 13;
    return (_jsxs("div", { style: {
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'stretch',
            justifyContent: 'space-between',
            gap: 18,
            padding: '9px 18px',
            fontFamily: 'Helvetica, Arial, sans-serif',
        }, children: [_jsxs("div", { style: { flex: 1, minWidth: 0 }, children: [_jsx("div", { style: {
                            fontWeight: 700,
                            color: INK,
                            fontSize: titleFontSize,
                            lineHeight: 1.5,
                            paddingBottom: EXPORT_CLIP_SLACK,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }, children: titleText }), subtitle ? (_jsx("div", { style: {
                            color: INK,
                            fontSize: 13,
                            lineHeight: 1.5,
                            marginTop: 2,
                            paddingBottom: EXPORT_CLIP_SLACK,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }, children: subtitle })) : null, description ? (_jsx("div", { style: {
                            color: MUTED,
                            fontSize: 12,
                            marginTop: 3,
                            lineHeight: 1.5,
                            paddingBottom: EXPORT_CLIP_SLACK,
                            // 4 line boxes at 1.5, plus the slack — box-sizing is border-box
                            // here, so without adding it back the padding would eat the 4th
                            // line. Band clips beyond.
                            maxHeight: `calc(6em + ${EXPORT_CLIP_SLACK}px)`,
                            overflow: 'hidden',
                            whiteSpace: 'pre-wrap', // honour the user's line breaks
                        }, children: description })) : null] }), _jsxs("div", { style: {
                    flexShrink: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'space-between',
                }, children: [_jsxs("div", { style: { fontSize: 11, lineHeight: 1.5, color: MUTED, textAlign: 'right' }, children: ["WGS 84", _jsx("br", {}), "EPSG:4326"] }), _jsx("img", { src: landscopeLogo, alt: "LandScope", style: { height: 36, width: 'auto', display: 'block' } })] })] }));
};
export default PrintTitleBlock;
